const state = {
    tenant_access: []
}

const mutations = {
    SET_TENANT_ACCESS(state, tenants) {
        state.tenant_access = tenants;
    }
}

const actions = {
    GET_TENANT_ACCESS({commit}, tenants) {
        commit('SET_TENANT_ACCESS', tenants);
    }
}

const getters = {
    tenants: state => {
        return state.tenant_access
    }
}

export default {namespaced: true, state, mutations, actions, getters}
